export const getPopupContentStyle = (isMobile: boolean): Record<string, string> => ({
  width: isMobile ? '100%' : 'auto',
  height: isMobile ? '100%' : 'auto',
  padding: isMobile ? '0.5rem 1rem 1rem' : '0.5rem 1.25rem 1rem',
});
